import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';

import {
	ITokenPayload,
	ITokenPayloadCognito,
} from '@/interfaces/auth/ITokenPayload';
import { StoredCookies } from '@/interfaces/auth/cookies.enum';
import { ICookieService } from '@/interfaces/services/ICookieService';

class CookieService<T extends ITokenPayload> implements ICookieService<T> {
	private ONE_YEAR_IN_MILISECONDS = 1000 * 60 * 60 * 24 * 365;
	private DEFAULT_COOKIE_OPTIONS = { path: '/' };

	cookies: Cookies;
	constructor() {
		this.cookies = new Cookies(this.DEFAULT_COOKIE_OPTIONS);
	}
	setUsernameCookie(
		username: string,
		expiresIn = this.ONE_YEAR_IN_MILISECONDS,
	) {
		const expires = new Date(Date.now() + expiresIn);
		this.cookies.set(StoredCookies.USERNAME, username, { ...this.DEFAULT_COOKIE_OPTIONS, expires });
	}

	setRefreshTokenCookie(
		refreshToken: string,
		expiresIn = this.ONE_YEAR_IN_MILISECONDS,
	) {
		const expires = new Date(Date.now() + expiresIn);
		this.cookies.set(StoredCookies.REFRESH_TOKEN, refreshToken, {
			...this.DEFAULT_COOKIE_OPTIONS,
			expires,
		});
	}
	setAccessTokenCookie(accessToken: string) {
		this.cookies.set(StoredCookies.ACCESS_TOKEN, accessToken, this.DEFAULT_COOKIE_OPTIONS);
	}
	getCookie(name: StoredCookies) {
		return this.cookies.get(name);
	}
	remove(name: StoredCookies) {
		try {
			this.cookies.remove(name, this.DEFAULT_COOKIE_OPTIONS);
			return true;
		} catch (error) {
			return false;
		}
	}
	removeAll() {
		const results = Object.values(StoredCookies).map(cookie => {
			const removed = this.remove(cookie);
			if (!removed) {
				try {
					this.cookies.remove(cookie, { path: '/' });
					this.cookies.remove(cookie, { path: '' });
					this.cookies.remove(cookie);
					return true;
				} catch {
					return false;
				}
			}
			return true;
		});

		return results.every(result => result);
	}
	decodeToken(token: string) {
		try {
			return jwtDecode<T>(token);
		} catch (error) {
			return null;
		}
	}
}

export const cookieService = new CookieService<ITokenPayloadCognito>();
